// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <div class="sub-header">
    <h2 class="sub-header__title">Non-product related transactions</h2>
  </div>

  <table class="miscellaneous-transactions__table table">
    <thead>
    <tr>
      <th>No</th>
      <th>Transaction name</th>
      <th></th>
    </tr>
    </thead>

    <tbody ng-if="\$ctrl.workingDay">
    <tr ng-repeat="transaction in \$ctrl.filteredTransactions">
      <td>{{\$index+1+'.'}}</td>
      <td>{{ transaction.isCommand ? transaction.name : (transaction.name | translate:'MISC_TRANSACTION') }}</td>
      <td>
        <button class="miscellaneous-transactions__open-button btn btn-primary"
           command-access="{{transaction.commandName}}"
           ng-disabled="!transaction.active || !transaction.redirectUrl"
           ng-click="\$ctrl.redirectToTransaction(transaction)">
          Open
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/miscellaneous-transactions.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;